module.exports = "<div>\n  <router-outlet></router-outlet>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /data/wwwroot/xzhipin/app-client/src/app/user-info/user-info.component.html
// module id = ../../../../../src/app/user-info/user-info.component.html
// module chunks = main